<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon" [class.cf-dlg-icon--blue]="isShortTermDebt">
      <mat-icon>{{ icon }}</mat-icon>
    </div>
    <div class="lo-header-text">
      <h2 class="cf-dlg-title">{{ title }}</h2>
      <p class="cf-dlg-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="close()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando movimientos…"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="savingMessage"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="lo-empty lo-empty--error">
        <mat-icon>error</mat-icon>
        <span>No se pudieron cargar los movimientos del préstamo.</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <div class="cf-dlg-body lo-body">

      <div class="lo-summary">
        <div class="lo-summary__left">
          <div class="lo-summary__icon-wrap"><mat-icon>account_balance_wallet</mat-icon></div>
          <div>
            <span class="lo-summary__label">Importe pendiente del préstamo</span>
            <span class="lo-summary__amount">{{ pendingAmount | number:'1.2-2' }} €</span>
            <span class="lo-summary__hint">
              Inicial {{ data.loan.importeInicial | number:'1.2-2' }} €
              <ng-container *ngIf="isInstallment"> · Capital pagado en {{ year }} {{ paidCapital | number:'1.2-2' }} € · Intereses {{ paidInterest | number:'1.2-2' }} €</ng-container>
              <ng-container *ngIf="!isInstallment && items.length"> · Registrado en {{ year }} {{ itemsTotal | number:'1.2-2' }} €</ng-container>
            </span>
          </div>
        </div>
        <div class="lo-summary__after" *ngIf="isInstallment && !editing && !invalidAmount">
          <span class="lo-summary__label">Pendiente tras este pago</span>
          <span class="lo-summary__after-amount" [class.lo-summary__after-amount--negative]="pendingAfterPayment < 0">{{ pendingAfterPayment | number:'1.2-2' }} €</span>
        </div>
      </div>

      <div class="lo-section">
        <span class="cf-dlg-section__label">
          {{ editing ? 'Editar movimiento' : 'Datos' }}
          <button *ngIf="editing" type="button" class="lo-link" (click)="cancelEdit()">Cancelar edición</button>
        </span>

        <div class="lo-grid">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingDate">
            <app-date [control]="control('fecha')" [config]="{ label: 'Fecha', required: true }"></app-date>
            <div class="cf-field__error" *ngIf="submitted && missingDate"><mat-icon>error</mat-icon> Indica la fecha</div>
          </div>

          <div class="cf-field--required lo-grid__wide" [class.cf-field--invalid]="submitted && missingConcept">
            <app-field [control]="control('concepto')" [config]="{ label: 'Concepto', type: 'text', required: true, maxLength: 100 }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && missingConcept"><mat-icon>error</mat-icon> Indica el concepto</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && invalidAmount">
            <app-field [control]="amountControl" [config]="{ label: amountLabel, type: 'number', required: true, inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && invalidAmount"><mat-icon>error</mat-icon> Indica un importe distinto de cero</div>
          </div>

          <div *ngIf="isConstitution">
            <app-field [control]="control('comisionApertura')" [config]="{ label: 'Comisión de apertura', type: 'number', inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
          </div>

          <div *ngIf="isInstallment">
            <app-field [control]="control('intereses')" [config]="{ label: 'Intereses', type: 'number', inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
          </div>

          <div *ngIf="!isShortTermDebt">
            <app-field [control]="control('gastosBancarios')" [config]="{ label: 'Gastos bancarios', type: 'number', inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingActivity">
            <app-autocomplete [control]="control('activity')" [config]="{ label: 'Actividad', placeholder: 'Seleccionar actividad…', options: activities, required: true, autoSelectSingle: true, strict: true }">
            </app-autocomplete>
            <div class="cf-field__error" *ngIf="submitted && missingActivity"><mat-icon>error</mat-icon> Selecciona la actividad</div>
          </div>

          <div *ngIf="needsBankAccount" class="cf-field--required" [class.cf-field--invalid]="submitted && missingBankAccount">
            <app-autocomplete [control]="control('bankAccount')" [config]="{ label: 'Cuenta bancaria', placeholder: 'Seleccionar cuenta…', options: bankAccounts, required: true, autoSelectSingle: true, strict: true }">
            </app-autocomplete>
            <div class="cf-field__error" *ngIf="submitted && missingBankAccount"><mat-icon>error</mat-icon> Selecciona la cuenta bancaria</div>
          </div>

          <div *ngIf="showProjects && projects.length">
            <app-autocomplete [control]="control('project')" [config]="{ label: 'Proyecto', placeholder: 'Sin proyecto', options: projects, strict: true }">
            </app-autocomplete>
          </div>

          <div *ngIf="showProjects && expenseProjectTypes.length">
            <app-autocomplete [control]="control('expenseProjectType')" [config]="{ label: 'Tipo de proyecto de gasto', placeholder: 'Sin tipo', options: expenseProjectTypes, strict: true }">
            </app-autocomplete>
          </div>
        </div>

        <div class="cf-dlg-mismatch" *ngIf="saveError">
          <mat-icon>error</mat-icon>
          <span>{{ saveError }}</span>
        </div>
      </div>

      <div class="lo-section">
        <span class="cf-dlg-section__label">{{ listTitle }}</span>

        <div class="lo-items" *ngIf="items.length; else emptyItems">
          <div class="lo-item" *ngFor="let item of items; trackBy: trackByUid" [class.lo-item--editing]="editing?.uid === item.uid">
            <div class="lo-item__main">
              <div class="lo-item__amount">{{ itemAmount(item) | number:'1.2-2' }} €</div>
              <div class="lo-item__meta" [title]="itemMeta(item)">{{ itemMeta(item) }}</div>
            </div>
            <div class="lo-item__date">{{ item.fecha | date:'dd/MM/yyyy' }}</div>
            <div class="lo-item__actions">
              <button mat-icon-button class="lo-item__btn" (click)="startEdit(item)" title="Editar" aria-label="Editar movimiento">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button class="lo-item__btn lo-item__btn--danger" (click)="remove(item)" title="Eliminar" aria-label="Eliminar movimiento">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <ng-template #emptyItems>
          <div class="lo-empty">
            <mat-icon>info</mat-icon>
            <span>{{ emptyText }}</span>
          </div>
        </ng-template>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="save()" [disabled]="saving">
        <mat-icon>{{ editing ? 'save' : 'check_circle' }}</mat-icon> {{ saveText }}
      </button>
    </div>
  </ng-container>
</div>
